export const APIS_QUERY_KEY = 'useAPIs';
